"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCyberAminoConverters = exports.isMsgSignData = exports.isAminoMsgWithdrawWithinBatch = exports.isAminoMsgDepositWithinBatch = exports.isAminoMsgSwapWithinBatch = exports.isAminoMsgCreatePool = exports.isAminoMsgEditRouteName = exports.isAminoMsgDeleteRoute = exports.isAminoMsgEditRoute = exports.isAminoMsgCreateRoute = exports.isAminoMsgInvestmint = exports.isAminoMsgCyberlink = void 0;
const utils_1 = require("@cosmjs/utils");
const long_1 = __importDefault(require("long"));
function isAminoMsgCyberlink(msg) {
    return msg.type === "cyber/MsgCyberlink";
}
exports.isAminoMsgCyberlink = isAminoMsgCyberlink;
function isAminoMsgInvestmint(msg) {
    return msg.type === "cyber/MsgInvestmint";
}
exports.isAminoMsgInvestmint = isAminoMsgInvestmint;
function isAminoMsgCreateRoute(msg) {
    return msg.type === "cyber/MsgCreateRoute";
}
exports.isAminoMsgCreateRoute = isAminoMsgCreateRoute;
function isAminoMsgEditRoute(msg) {
    return msg.type === "cyber/MsgEditRoute";
}
exports.isAminoMsgEditRoute = isAminoMsgEditRoute;
function isAminoMsgDeleteRoute(msg) {
    return msg.type === "cyber/MsgDeleteRoute";
}
exports.isAminoMsgDeleteRoute = isAminoMsgDeleteRoute;
function isAminoMsgEditRouteName(msg) {
    return msg.type === "cyber/MsgEditRouteName";
}
exports.isAminoMsgEditRouteName = isAminoMsgEditRouteName;
function isAminoMsgCreatePool(msg) {
    return msg.type === "liquidity/MsgCreatePool";
}
exports.isAminoMsgCreatePool = isAminoMsgCreatePool;
function isAminoMsgSwapWithinBatch(msg) {
    return msg.type === "liquidity/MsgSwapWithinBatch";
}
exports.isAminoMsgSwapWithinBatch = isAminoMsgSwapWithinBatch;
function isAminoMsgDepositWithinBatch(msg) {
    return msg.type === "liquidity/MsgDepositWithinBatch";
}
exports.isAminoMsgDepositWithinBatch = isAminoMsgDepositWithinBatch;
function isAminoMsgWithdrawWithinBatch(msg) {
    return msg.type === "liquidity/MsgWithdrawWithinBatch";
}
exports.isAminoMsgWithdrawWithinBatch = isAminoMsgWithdrawWithinBatch;
function isMsgSignData(msg) {
    const castedMsg = msg;
    if (castedMsg.type !== "sign/MsgSignData")
        return false;
    if (!(0, utils_1.isNonNullObject)(castedMsg.value))
        return false;
    if (typeof castedMsg.value.signer !== "string")
        return false;
    if (typeof castedMsg.value.data !== "string")
        return false;
    return true;
}
exports.isMsgSignData = isMsgSignData;
function omitDefault(input) {
    if (typeof input === "string") {
        return input === "" ? undefined : input;
    }
    if (typeof input === "number") {
        return input === 0 ? undefined : input;
    }
    if (long_1.default.isLong(input)) {
        return input.isZero() ? undefined : input;
    }
    throw new Error(`Got unsupported type '${typeof input}'`);
}
function createCyberAminoConverters() {
    return {
        "/cyber.graph.v1beta1.MsgCyberlink": {
            aminoType: "cyber/MsgCyberlink",
            toAmino: ({ neuron, links }) => {
                return {
                    neuron: neuron,
                    links: links,
                };
            },
            fromAmino: ({ neuron, links }) => {
                return {
                    neuron: neuron,
                    links: links, // need to refactor other ...
                };
            },
        },
        "/cyber.resources.v1beta1.MsgInvestmint": {
            aminoType: "cyber/MsgInvestmint",
            toAmino: ({ neuron, amount, resource, length }) => {
                (0, utils_1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    neuron: neuron,
                    amount: amount,
                    resource: resource,
                    length: length.toString(),
                };
            },
            fromAmino: ({ neuron, amount, resource, length }) => ({
                neuron: neuron,
                amount: amount,
                resource: resource,
                length: long_1.default.fromString(length),
            }),
        },
        "/cyber.grid.v1beta1.MsgCreateRoute": {
            aminoType: "cyber/MsgCreateRoute",
            toAmino: ({ source, destination, name }) => ({
                source: source,
                destination: destination,
                name: name,
            }),
            fromAmino: ({ source, destination, name }) => ({
                source: source,
                destination: destination,
                name: name,
            }),
        },
        "/cyber.grid.v1beta1.MsgEditRoute": {
            aminoType: "cyber/MsgEditRoute",
            toAmino: ({ source, destination, value }) => {
                (0, utils_1.assertDefinedAndNotNull)(value, "missing value");
                return {
                    source: source,
                    destination: destination,
                    value: value,
                };
            },
            fromAmino: ({ source, destination, value }) => ({
                source: source,
                destination: destination,
                value: value,
            }),
        },
        "/cyber.grid.v1beta1.MsgDeleteRoute": {
            aminoType: "cyber/MsgDeleteRoute",
            toAmino: ({ source, destination }) => ({
                source: source,
                destination: destination,
            }),
            fromAmino: ({ source, destination }) => ({
                source: source,
                destination: destination,
            }),
        },
        "/cyber.grid.v1beta1.MsgEditRouteName": {
            aminoType: "cyber/MsgEditRouteName",
            toAmino: ({ source, destination, name }) => ({
                source: source,
                destination: destination,
                name: name,
            }),
            fromAmino: ({ source, destination, name }) => ({
                source: source,
                destination: destination,
                name: name,
            }),
        },
        "/cyber.liquidity.v1beta1.MsgCreatePool": {
            aminoType: "liquidity/MsgCreatePool",
            toAmino: ({ poolCreatorAddress, poolTypeId, depositCoins, }) => ({
                pool_creator_address: poolCreatorAddress,
                pool_type_id: poolTypeId,
                deposit_coins: [...depositCoins],
            }),
            fromAmino: ({ pool_creator_address, pool_type_id, deposit_coins, }) => ({
                poolCreatorAddress: pool_creator_address,
                poolTypeId: pool_type_id,
                depositCoins: [...deposit_coins],
            }),
        },
        "/cyber.liquidity.v1beta1.MsgSwapWithinBatch": {
            aminoType: "liquidity/MsgSwapWithinBatch",
            toAmino: ({ swapRequesterAddress, poolId, swapTypeId, offerCoin, demandCoinDenom, offerCoinFee, orderPrice, }) => {
                const order_price = orderPrice.split("");
                while (order_price.length < 19) {
                    order_price.unshift("0");
                }
                order_price.splice(order_price.length - 18, 0, ".");
                return {
                    swap_requester_address: swapRequesterAddress,
                    pool_id: "" + omitDefault(poolId)?.toString(),
                    swap_type_id: swapTypeId,
                    offer_coin: offerCoin,
                    demand_coin_denom: demandCoinDenom,
                    offer_coin_fee: offerCoinFee,
                    order_price: order_price.join(""),
                };
            },
            fromAmino: ({ swap_requester_address, pool_id, swap_type_id, offer_coin, demand_coin_denom, offer_coin_fee, order_price, }) => {
                return {
                    swapRequesterAddress: swap_requester_address,
                    poolId: long_1.default.fromNumber(parseInt(pool_id, 10) || 0),
                    swapTypeId: swap_type_id,
                    offerCoin: offer_coin,
                    demandCoinDenom: demand_coin_denom,
                    offerCoinFee: offer_coin_fee,
                    orderPrice: order_price.replace(".", "").replace(/^0+/, ""),
                };
            },
        },
        "/cyber.liquidity.v1beta1.MsgDepositWithinBatch": {
            aminoType: "liquidity/MsgDepositWithinBatch",
            toAmino: ({ depositorAddress, poolId, depositCoins, }) => ({
                depositor_address: depositorAddress,
                pool_id: "" + omitDefault(poolId)?.toString(),
                deposit_coins: [...depositCoins],
            }),
            fromAmino: ({ depositor_address, pool_id, deposit_coins, }) => ({
                depositorAddress: depositor_address,
                poolId: long_1.default.fromNumber(parseInt(pool_id, 10) || 0),
                depositCoins: [...deposit_coins],
            }),
        },
        "/cyber.liquidity.v1beta1.MsgWithdrawWithinBatch": {
            aminoType: "liquidity/MsgWithdrawWithinBatch",
            toAmino: ({ withdrawerAddress, poolId, poolCoin, }) => ({
                withdrawer_address: withdrawerAddress,
                pool_id: "" + omitDefault(poolId)?.toString(),
                pool_coin: poolCoin,
            }),
            fromAmino: ({ withdrawer_address, pool_id, pool_coin, }) => ({
                withdrawerAddress: withdrawer_address,
                poolId: long_1.default.fromNumber(parseInt(pool_id, 10) || 0),
                poolCoin: pool_coin,
            }),
        },
    };
}
exports.createCyberAminoConverters = createCyberAminoConverters;
//# sourceMappingURL=aminomsgs.js.map